
import {Component, Prop, Vue} from "vue-property-decorator";
import {ALL_STATES} from '@pazion/pazion-core/src/views/queue/utils'
import type {IQueueJobState} from '@pazion/pazion-core/src/views/queue/utils'

@Component
export default class QueueJobState extends Vue {

  @Prop({default: ''})
  public state!: string;

  get stateObject(): IQueueJobState | undefined {
    const currentState = this.state;
    return ALL_STATES.find(function (state) {
      return (state.nameTech === currentState);
    });
  }

  get stateColor() {
    return this.stateObject?.color;
  }

  get stateLabel() {
    return this.stateObject?.label;
  }
}
